<template>
  <page>
      <v-expansion-panels  v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Date Range
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.fromDate" :label="labels.fromDate" v-validate="'required'" :data-vv-as="labels.fromDate" data-vv-name="fromDate" :error-messages="errors.collect('fromDate')"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.toDate" :label="labels.toDate" v-validate="toDateValidation(reportForm.fromDate)" :data-vv-as="labels.toDate" data-vv-name="toDate" :error-messages="errors.collect('toDate')" :min="this.reportForm.uwTransDateFrom"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.fromDate1" :label="labels.fromDate1" v-validate="'required'" :data-vv-as="labels.fromDate1" data-vv-name="fromDate1" :error-messages="errors.collect('fromDate1')"></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <cal-picker v-model="reportForm.toDate1" :label="labels.toDate1" v-validate="toDateValidation(reportForm.fromDate1)" :data-vv-as="labels.toDate1" data-vv-name="toDate1" :error-messages="errors.collect('toDate1')" :min="this.reportForm.clmTransDateFrom"></cal-picker>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels  v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
    <v-card>
      <v-card-text>
        <v-form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="reportForm.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch" append-icon="mdi-magnify" @click:append="getHelpList('branch')" v-validate="'required'" readonly></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="reportForm.insdRef" :label="labels.insdRef" :error-messages="errors.collect('insdRef')" data-vv-name="insdRef" :data-vv-as="labels.insdRef" append-icon="mdi-magnify" @click:append="getHelpList('insdRef')" v-validate="'required'" readonly></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-dialog v-model="brnFilter" width="900px" persistent>
          <branch-filter :menu="menu" @close="doClose" @doAssign="doAssign($event)"></branch-filter>
        </v-dialog>
        <v-dialog v-model="insdFilter" width="900px" persistent>
          <insured-filter :menu="menu" @close="doClose" @doAssign="doAssign($event)"></insured-filter>
        </v-dialog>
      </v-card-text>
    </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
              <v-flex lg6 xs12>
                <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="reportForm.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import BranchFilter from './BranchFilter.vue'
import InsuredFilter from '@/components/core/common/dialog/InsuredFilter.vue'

export default {
  data() {
    return {
      labels: {
        fromDate: 'Underwriting Transaction Date From*',
        toDate: 'Underwriting Transaction Date To*',
        fromDate1: 'Claims Transaction Date From*',
        toDate1: 'Claims Transaction Date To*',
        branch: 'Branch',
        insdRef: 'Insured Reference',
        format: 'Export Format',
        export: 'Export to',
        sendEmail: 'Send Output to Email?',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        fromDate: new Date(),
        toDate: new Date(),
        fromDate1: new Date(),
        toDate1: new Date(),
        branch: 'All',
        insdRef: 'All',
        format: undefined,
        sendEmail: false,
        printRptRunTime: true
      },
      menu: {},
      supportedFormat: [],
      filterList: false,
      brnFilter: false,
      insdFilter: false,
      submitting: false,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.init !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initCltProfStat
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    toDateValidation(fromDate) {
      const result = 'required|from_to_date:' + fromDate
      return result
    },
    getHelpList(fieldName) {
      if (fieldName === 'branch') {
        this.brnFilter = true
        this.insdFilter = false
      } else {
        this.brnFilter = false
        this.insdFilter = true
      }
    },
    doClose(fieldName) {
      if (fieldName === 'branch') {
        this.brnFilter = false
      } else {
        this.insdFilter = false
      }
    },
    doAssign(data) {
      if (this.brnFilter) {
        this.reportForm.branch = []
        this.reportForm.branch = data.finalSelectedItems.toString()
      } else {
        this.reportForm.insdRef = []
        this.reportForm.insdRef = data.finalSelectedItems.toString()
      }
      this.brnFilter = false
      this.insdFilter = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    BranchFilter,
    InsuredFilter
  }
}
</script>
